import Text from '@atoms/Text/Text';
import Link from '@atoms/Link/Link';
import paths from '@constants/paths';
import { useTranslations } from 'next-intl';
import { StyledInfoBox, StyledLinkWrapper, StyledWrapper } from './StoreSearchEmptyState.styles';

interface Props {
  searchTerm: string;
  className?: string;
}

const StoreSearchEmptyState = ({ searchTerm, className }: Props) => {
  const t = useTranslations('storefinder');

  return (
    <StyledWrapper className={className}>
      <StyledInfoBox>
        <Text type="body" size="small" align="center">
          {t('storeNotFound.title', { search: searchTerm })}
        </Text>
      </StyledInfoBox>

      <Text type="body" size="small" align="center">
        {t('storeNotFound.body')}
      </Text>
      <Text type="body" size="small" align="center">
        {t('storeNotFound.notfound')}
      </Text>
      <StyledLinkWrapper>
        <Text type="body" size="small" align="center">
          <Link href={paths.ALL_STORES}>{t('storeNotFound.link')}</Link>
        </Text>
      </StyledLinkWrapper>
    </StyledWrapper>
  );
};

export default StoreSearchEmptyState;
